import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { startGetProveedores, cleanProveedorForm } from "../../../context/actions/proveedoresActions";
import CardPage from "../../../layout/CardPage";
import Agregar from "../agregar/Agregar";
import Tabla from "./Tabla";
import { Button, Modal } from "antd";

////
export default function Listado() {
  const [openModal, setOpenModal] = useState(false);

  const { Backoffice_AltaProveedores } = useSelector((state) => state.userReducer.user);

  const dispatch = useDispatch();

  const handleAgregar = () => setOpenModal(true);

  const handleCloseModal = () => {
    setOpenModal(false);
  };

  const handleSuccess = () => {
    setOpenModal(false);
    dispatch(cleanProveedorForm());
  };

  ////
  return (
    <CardPage
      titulo="Proveedores"
      tituloBoton={Backoffice_AltaProveedores && "Agregar"}
      accionBoton={handleAgregar}
    >
      <Tabla />

      <Modal width={900} onCancel={handleCloseModal} open={openModal} footer={<Button danger key={'cerrar'} onClick={handleCloseModal}>Cerrar</Button>}>
        <Agregar onSuccess={handleSuccess} />
      </Modal>
    </CardPage>
  );
}
